import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'flat-select',
  templateUrl: './flat-select.component.html',
  styleUrls: ['./flat-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlatSelectComponent implements OnInit {

  @Input() options: {
    label: string
    value: any
  }[] = []

  @Input() value
  @Output() valueChange = new EventEmitter()

  constructor() { }

  ngOnInit() {
  }

}
